<script lang="ts" setup>
import PrivacyPolicy from "./policies/privacy-policy.md";
import TermsOfService from "./policies/terms-of-service.md";
import YongHuXieYi from "./policies/yong-hu-xie-yi.md";
import YinSiZhengCe from "./policies/yin-si-zheng-ce.md";
import CommunityGuidelines from "./policies/community-guidlines.md";
import ContentRemovalPolicy from "./policies/content-removal-policy.md";
import ComplaintsPolicy from "./policies/complaints-policy.md";
import { useRoute } from "vue-router";

const route = useRoute();
</script>
<template>
  <div class="h-full w-full overflow-hidden flex flex-col">
    <ThreadsNav class="w-full" :show-center="false" show-back />
    <div class="p-4 overflow-y-auto w-full">
      <div
        class="w-full prose prose-sm lg:prose-base overflow-hidden max-w-full"
      >
        <PrivacyPolicy v-if="route.query.type === 'privacy-policy'" />
        <TermsOfService v-if="route.query.type === 'terms-of-service'" />
        <CommunityGuidelines
          v-if="route.query.type === 'community-guidelines'"
        />
        <ContentRemovalPolicy
          v-if="route.query.type === 'content-removal-policy'"
        />
        <ComplaintsPolicy v-if="route.query.type === 'complaints-policy'" />
        <YongHuXieYi v-if="route.query.type === 'user-agreement-cn'" />
        <YinSiZhengCe
          v-if="route.query.type === 'privacy-policy-cn'"
          class="break-all"
        />
      </div>
    </div>
  </div>
</template>
